import { useState } from 'react';
import QuoteForm from './QuoteForm';

export default function CtaSection() {
  const [showForm, setShowForm] = useState(false);

  return (
    <>
      <section className="py-16 bg-emerald-700">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Want a firm quote with turnaround dates?
          </h2>
          <p className="text-xl text-emerald-100 mb-8">
            Share your site details and we'll provide a detailed quote within 24 hours.
          </p>
          <button
            onClick={() => setShowForm(true)}
            className="bg-white text-emerald-700 px-8 py-4 rounded-md text-lg font-semibold hover:bg-stone-100 transition-colors whitespace-nowrap"
          >
            Get a Firm Quote
          </button>
        </div>
      </section>

      {showForm && <QuoteForm onClose={() => setShowForm(false)} />}
    </>
  );
}
